
import MultiStepForm from '../RegistrationForm/MultiStepForm';

const Home = () => {
    return (
        <div>
            <MultiStepForm />
        </div>
    );
};

export default Home;